// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpVerificationContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.verificationText {
  font-family: "Poppins", sans-serif;
  font-weight: 600px;
  font-size: 24px;
  line-height: 32px;
}
.enterText {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
}
.enterOtpContainer {
  display: flex;
  align-items: start;
  flex-direction: column;
  margin-top: 56px;
}
.enterOtpText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.otpInputContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.otpInput {
  all: unset;
  border: 1px solid #6a6a6a;
  height: 80px;
  width: 80px;
  border-radius: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.forgetPasswordTimer {
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #48d1cc;
  line-height: 24px;
  margin-top: 30px;
}
.resendCodeContainer {
  margin-top: 20px;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.resendBtn-disabled {
  all: unset;
}
.resendBtn-active {
  all: unset;
  color: #48d1cc;
  cursor: pointer;
}

@media (max-width: 1640px) {
  .enterOtpContainer {
    margin-top: 50px;
  }
  .forgetPasswordTimer {
    font-size: 15px;
    line-height: 20px;
    margin-top: 25px;
  }
}
@media (max-width: 1440px) {
  .enterOtpContainer {
    margin-top: 40px;
  }
  .forgetPasswordTimer {
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }
}
@media (max-width: 1280px) {
  .enterOtpContainer {
    margin-top: 30px;
  }
  .forgetPasswordTimer {
    font-size: 13px;
    line-height: 16px;
    margin-top: 15px;
  }
}
@media (max-width: 1024px) {
  .enterOtpContainer {
    margin-top: 20px;
  }
  .forgetPasswordTimer {
    font-size: 12px;
    line-height: 14px;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/OtpVerification/OtpVerification.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.otpVerificationContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.verificationText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.enterText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n  margin-top: 12px;\n}\n.enterOtpContainer {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n  margin-top: 56px;\n}\n.enterOtpText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.otpInputContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n.otpInput {\n  all: unset;\n  border: 1px solid #6a6a6a;\n  height: 80px;\n  width: 80px;\n  border-radius: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 18px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.forgetPasswordTimer {\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  color: #48d1cc;\n  line-height: 24px;\n  margin-top: 30px;\n}\n.resendCodeContainer {\n  margin-top: 20px;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.resendBtn-disabled {\n  all: unset;\n}\n.resendBtn-active {\n  all: unset;\n  color: #48d1cc;\n  cursor: pointer;\n}\n\n@media (max-width: 1640px) {\n  .enterOtpContainer {\n    margin-top: 50px;\n  }\n  .forgetPasswordTimer {\n    font-size: 15px;\n    line-height: 20px;\n    margin-top: 25px;\n  }\n}\n@media (max-width: 1440px) {\n  .enterOtpContainer {\n    margin-top: 40px;\n  }\n  .forgetPasswordTimer {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 20px;\n  }\n}\n@media (max-width: 1280px) {\n  .enterOtpContainer {\n    margin-top: 30px;\n  }\n  .forgetPasswordTimer {\n    font-size: 13px;\n    line-height: 16px;\n    margin-top: 15px;\n  }\n}\n@media (max-width: 1024px) {\n  .enterOtpContainer {\n    margin-top: 20px;\n  }\n  .forgetPasswordTimer {\n    font-size: 12px;\n    line-height: 14px;\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
